import React from "react";
import "./CarRentalData.css";

const CarRentalData = () => {
  const YouTubePreview = ({ videoId }) => {
    const [play, setPlay] = React.useState(false);

    return (
      <div className="yt-container">
        {!play ? (
          <div className="yt-thumbnail" onClick={() => setPlay(true)}>
            <img
              src={`https://img.youtube.com/vi/${videoId}/hqdefault.jpg`}
              alt="video thumbnail"
            />
            <div className="play-button"></div>
          </div>
        ) : (
          <iframe
            width="100%"
            height="350"
            src={`https://www.youtube.com/embed/${videoId}?autoplay=1`}
            title="YouTube video"
            frameBorder="0"
            allow="autoplay; encrypted-media"
            allowFullScreen
          ></iframe>
        )}
      </div>
    );
  };
  return (
    <div className="guidance-container">
      <h1 className="main-title">RENT A CAR</h1>

      <div className="timeline">
        <div className="timeline-item">
          <div className="circle"></div>
          <div className="content">
            <h3>1. Introduction</h3>

            <p>Rent a Car – Travel Comfortably with ZikRme</p>

            <p>
              Enjoy the freedom of comfortable travel with ZikRme Car Rental
              Service. Whether you're planning a business trip, a family
              vacation, or a local city ride, our rental cars provide
              convenience, reliability, and flexibility.
            </p>

            <p>
              Choose from a wide range of well-maintained vehicles and travel at
              your own pace with Self Drive or With Driver options.
            </p>

            <p>
              With simple booking directly through the ZikRme platform, renting
              a car has never been easier.
            </p>
          </div>
        </div>

        <div className="timeline-item">
          <div className="circle"></div>
          <div className="content">
            <h3>2. About ZikRme Car Rental Service</h3>

            <p>
              ZikRme offers reliable and affordable car rental services designed
              for travelers, professionals, and families who want flexible
              transportation.
            </p>

            <p>
              Our cars are regularly maintained, insured, and ready for a safe
              journey. Whether you need a car for a few hours, a full day, or a
              longer trip, ZikRme provides flexible rental options to match your
              travel needs.
            </p>

            <p>
              Book your car directly on the ZikRme platform and enjoy a smooth
              and hassle-free rental experience.
            </p>
          </div>
        </div>

        <div className="timeline-item">
          <div className="circle"></div>
          <div className="content">
            <h3>3. Cars Available for Rent</h3>
            <p>Choose the perfect car based on your travel needs.</p>
            <ul>
              <li>
                <b>Hatchback</b> – Budget-friendly option for local city travel.
              </li>
              <li>
                <b>Sedan</b> – Comfortable and spacious for business or family
                rides.
              </li>
              <li>
                <b>SUV</b> – Ideal for family trips, group travel, and
                long-distance journeys.
              </li>
              <li>
                <b>Tempo Traveller</b> – Best for group tours and large travel
                groups.
              </li>
            </ul>
          </div>
        </div>

        <div className="timeline-item">
          <div className="circle"></div>
          <div className="content">
            <h3>4. Features of ZikRme Car Rental</h3>

            <ul>
              <li>Clean and well-maintained vehicles</li>
              <li>Fully insured rental cars</li>
              <li>Self Drive and Driver options available</li>
              <li>Flexible pickup and return timing</li>
              <li>Affordable and transparent pricing</li>
              <li>Roadside support available on call</li>
            </ul>
          </div>
        </div>

        <div className="timeline-item">
          <div className="circle"></div>
          <div className="content">
            <h3>5. Rental Modes</h3>
            <p>Choose the rental mode that suits your travel style.</p>
            <p>
              <b>Self Drive</b>
            </p>
            <p>
              Drive the car yourself and enjoy complete freedom and privacy
              during your journey.
            </p>

            <p>
              <b>With Driver</b>
            </p>
            <p>
              Relax and enjoy your trip while a professional driver handles the
              travel.
            </p>
          </div>
        </div>

        <div className="timeline-item">
          <div className="circle"></div>
          <div className="content">
            <h3>6. Flexible Rental Plans</h3>
            <p>
              ZikRme provides flexible rental plans to suit different travel
              needs.
            </p>
            <ul>
              <li>Hourly Rental – Perfect for short city travel</li>
              <li>Daily Rental – Ideal for full-day travel plans</li>
              <li>Weekly Rental – Best for long trips or extended travel</li>
              <li>
                Doorstep Delivery & Pickup (Available in selected locations)
              </li>
            </ul>
          </div>
        </div>

        <div className="timeline-item">
          <div className="circle"></div>
          <div className="content">
            <h3>7. Documents Required</h3>
            <p>To rent a car, the following documents are required:</p>
            <ul>
              <li>Valid Driving License</li>
              <li>Government ID Proof (Aadhaar / Passport / Voter ID)</li>
              <li>Security Deposit (Refundable)</li>
            </ul>
          </div>
        </div>

        <div className="timeline-item">
          <div className="circle"></div>
          <div className="content">
            <h3>8. Why Choose ZikRme Car Rental?</h3>

            <ul>
              <li>Easy booking directly on the ZikRme platform</li>
              <li>Affordable pricing with no hidden charges</li>
              <li>Reliable and well-maintained cars</li>
              <li>Flexible rental durations</li>
              <li>Professional customer support</li>
              <li>Trusted by travelers and professionals</li>
            </ul>
          </div>
        </div>

        <div className="timeline-item">
          <div className="circle"></div>
          <div className="content">
            <h3>9. How to Rent a Car</h3>

            <ul>
              <li>Visit the ZikRme Car Rental page</li>
              <li>Select your preferred vehicle</li>
              <li>Choose rental duration and pickup location</li>
              <li>Complete the booking through the platform</li>
            </ul>
          </div>
        </div>
        <div className="timeline-item">
          <div className="circle"></div>
          <div className="content">
            <h3>10. How to Rent a Car on ZikRme</h3>
            <p>
              New to ZikRme rentals? Watch our quick tutorial to understand how
              to rent a car through the platform.
            </p>
            <YouTubePreview videoId="dQw4w9WgXcQ" />
            <p>In this video you will learn:</p>
            <ul>
              <li>How to choose a car for rent</li>
              <li>Self drive vs driver options</li>
              <li>Rental duration and pricing</li>
              <li>How to confirm your booking on ZikRme</li>
            </ul>
          </div>
        </div>
        <div className="timeline-item">
          <div className="circle"></div>
          <div className="content">
            <h3>11. Book Your Car Now</h3>
            <p>Reserve Your Car Instantly</p>
            <p>Book Now on ZikRme Platform</p>
            <p>
              Select your car, choose your rental plan, and start your journey
              with ease.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CarRentalData;
